import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { CustomerWithResolvedRefs, PaginatedResponse } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SearchCustomersParams } from '../api';
import { createCustomerApi, customerKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseCustomersOptions extends SearchCustomersParams {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useCustomers(
  options?: UseCustomersOptions,
): UseQueryResult<PaginatedResponse<CustomerWithResolvedRefs>> {
  const client = useApiClient('deliveries');
  const api = createCustomerApi(client);

  const { enabled, ...filters } = options ?? {};

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: (): Promise<PaginatedResponse<CustomerWithResolvedRefs>> => api.searchCustomers(filters),
    queryKey: customerKeys.list(filters),
    staleTime: LIST_STALE_TIME_MS,
  });
}
